<template>
    <div class="reply">
        回复我的
    </div>
</template>

<script>
    export default {
        name: "ReplyList"
    }
</script>

<style scoped>
    .reply{
        width: 60%;
        margin: 0 auto;
    }
</style>
